import { getFeatureValue } from "../utils/growthbookClient";

const SUPPORTED_DIRECT_DEBIT_COUNTRIES = [
  "GB",
  "NL",
  "FR",
  "DE",
  "AT",
  "ES",
  "AU",
  "BE",
  "CY",
  "EE",
  "IE",
  "IT",
  "LV",
  "LU",
  "MC",
  "PT",
  "SM",
  "SI",
];

const DEFAULT_TYPE_ORDER = [
  "paypal",
  "card",
  "gocardless",
  "ideal",
  "sofort",
  "giropay",
];

const SOFORT_SUPPORTED_COUNTRIES = ["AT", "BE", "DE", "NL", "ES", "GB"];
const SOFORT_SUPPORTED_CURRENCIES = ["EUR", "GBP"];

const PAYPAL_NOT_SUPPORTED_CURRENCIES = ["ARS"];
const DEFAULT_TYPE = "card";

export const orderPaymentMethods = (
  paymentMethods: string[],
  order: string[]
): string[] => {
  const orderedMethods = order.filter((method) =>
    paymentMethods.includes(method)
  );
  const additionalMethods = paymentMethods.filter(
    (method) => !order.includes(method)
  );
  const result = [...orderedMethods, ...additionalMethods];
  return Array.from(new Set(result));
};

export const isDirectDebitSupported = (country: string): boolean =>
  SUPPORTED_DIRECT_DEBIT_COUNTRIES.includes(country);

export const isPaypalSupported = (currency: string): boolean =>
  !PAYPAL_NOT_SUPPORTED_CURRENCIES.includes(currency);

const sofortSupported = (
  country: string,
  amount: number,
  currency: string
): boolean => {
  if (!SOFORT_SUPPORTED_COUNTRIES.includes(country)) return false;

  if (!SOFORT_SUPPORTED_CURRENCIES.includes(currency)) return false;

  if (amount < 1 || amount > 5000) return false;

  if (country == "GB" && currency != "GBP") return false;
  if (currency == "GBP" && country != "GB") return false;

  return true;
};

export const getLocalPaymentMethods = (
  currency: string,
  country: string,
  donationAmount: number
): string[] => {
  const localPaymentMethods: string[] = [];

  if (currency === "EUR") {
    // IDEAL
    if (country === "NL") localPaymentMethods.push("ideal");
    // GIROPAY
    if (country === "DE") localPaymentMethods.push("giropay");
  }

  if (sofortSupported(country, donationAmount, currency))
    localPaymentMethods.push("sofort");

  return localPaymentMethods;
};

export const fetchPaymentTypes = (
  currency: string,
  country: string,
  amount: number,
  controlOrder: string[]
): string[] => {
  const orderingData = getFeatureValue("payment_type_ordering", {});
  let ordering = orderingData[currency]
    ? orderingData[currency]
    : DEFAULT_TYPE_ORDER;

  let paymentTypes: string[] = [DEFAULT_TYPE];

  if (isPaypalSupported(currency)) paymentTypes.push("paypal");

  if (isDirectDebitSupported(country)) paymentTypes.push("gocardless");

  const localPaymentMethods = getLocalPaymentMethods(currency, country, amount);

  const paymentTypesSet = new Set([...paymentTypes, ...localPaymentMethods]);

  paymentTypes = Array.from(
    orderPaymentMethods(Array.from(paymentTypesSet), ordering)
  );
  return paymentTypes;
};
